var _defs, _path, _polygon, _polygon2, _polygon3, _rect, _rect2, _g, _text, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElistairLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1429.37 238.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        font-family: PresicavRg-Regular, Presicav;\n        font-size: 46.35px;\n      }\n\n      .cls-3 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-4 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-5 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-6 {\n        letter-spacing: -.04em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M771.46,60.6c0,19.96,16.18,36.14,36.14,36.14h72.29v24.1h-96.5l-11.81,24.1h96.27c19.96,0,36.14-16.18,36.14-36.14s-16.18-36.14-36.14-36.14h-72.29v-24.1h96.14s11.68-24.1,11.68-24.1h-95.77c-19.96,0-36.14,16.18-36.14,36.14Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1060.6 48.55 1060.6 24.45 928.08 24.45 928.08 48.55 982.29 48.55 982.29 144.93 1006.39 144.93 1006.39 48.55 1060.6 48.55"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "590.74 24.45 566.65 24.45 566.65 144.93 590.74 144.93 699.17 144.93 699.17 120.83 590.74 120.83 590.74 24.45"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "410.03 24.45 410.03 144.93 542.55 144.93 542.55 120.83 434.12 120.83 434.12 96.74 518.46 96.74 518.46 72.64 434.12 72.64 434.12 48.55 542.55 48.55 542.55 24.45 410.03 24.45"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 723.27,
    y: 24.45,
    width: 24.1,
    height: 120.48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1224.06,
    y: 24.45,
    width: 24.1,
    height: 120.48
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.33,213.41l22.99-47.15h268.21l22.99,47.15H24.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.22,24.83l-22.99,47.15H47.32L24.33,24.83h120.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.53,24.83l-22.99,47.15h-72.77l-22.99-47.15h118.76Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "216.65 24.83 193.76 71.76 169.76 71.76 146.87 24.83 95.01 24.83 140.9 118.91 222.63 118.91 268.51 24.83 216.65 24.83"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(407.12 213.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 0,
    y: 0
  }, "PE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 76.99,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 117.22,
    y: 0
  }, "SI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 170.48,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 209.04,
    y: 0
  }, "TENT AERIAL INTELLIGENCE "))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1380.57,94.75c14.33-4.9,24.61-18.54,24.41-34.58-.25-19.91-17.21-35.6-37.12-35.6h-95.14v120.24h24.05v-48.1h58.31l23.46,48.1h26.45l-24.41-50.06ZM1380.94,48.62v24.05h-72.14s0,0,0,0h-12.02v-24.05h84.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1106.34,24.34l-58.86,120.7h26.55l11.77-24.14h82.92l11.77,24.14h26.55l-58.86-120.7h-41.85ZM1097.57,96.76l29.69-60.88,6.14,12.6,23.55,48.28h-59.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElistairLogo);
export default __webpack_public_path__ + "static/media/elistair-logo.4bfd8e6ea10fa5485c6362aa7452b5fb.svg";
export { ForwardRef as ReactComponent };